import {fetchGet, generateEndpoint} from "../../../utils/request";

export const getPosts = async() => {
  const url = `${generateEndpoint('getPosts')}`
  return fetchGet(url, null)
}